import Authorizations from './Authorizations'

export default Authorizations
